<template>
  <div class="chatComponent">
    <div class="inputArea">
      <input type="text" v-model="message" class="message" ><br>
      <div v-if="this.isSold">
        <button @click="addChat" class="btn send">送信する</button>
      </div>
      <div v-else>
        <button class="btn soldOut">売り切れ</button>
      </div>
    </div>
    <section>
      <div v-for="chat in chats" :key="chat.index" class="messageBoard item" >
          <!-- <div class="item-image">
            <img :src="chat.profilePhoto" width="40" height="40" />
          </div> -->
              <!-- ユーザ名を表示 -->
              <div class="item-name">{{chat.userName}}<p v-if="userID == chat.uid" style="color: red;">(出品者)</p></div>
              <div class="item-detail">
              <div class="item-message">
                <!-- テキストを表示 改行コード<br>に変換される。 -->
                <p>{{chat.message}}</p>
              </div>
            </div>
      </div>  
    </section>
  </div> 
</template>

<script>
import firebase from "firebase";
import db from "../plugins/firestore";
// 改行を <br> タグに変換するモジュール
import Nl2br from 'vue-nl2br'

export default {
    component: { Nl2br },
    props: ["itemID", "user", "userID", "item", "isSold"], //ItemDetail.vueからのprops itemIDは商品ID、userはログイン中のユーザ、userIDは出品者ID、itemは商品名
        data() {
        return {
            chats: [], //チャットが格納されている配列
            message: "", //メッセージ
            // userID:''
        };
    },
    //chatコレクションにドキュメントが追加される度に（内容が変更されるたびに）getChats()が呼ばれて、
    //チャットデータを取得する。
    //onSnapshot()メソッドでリスナをセットすることで、ドキュメントの変更時にコールバックを受けることが出来る。
    //変更とは、具体的には、追加・削除・変更であり、削除時にはnullが返ってくるものと思われる。
    mounted() {
        db.collection("textbooks").doc(this.itemID).collection("chat").onSnapshot(() => {
            this.getChats();
        });
    },
    methods: {
        //チャットデータ取得
        getChats(){
            //商品のサブコレクションに格納されているチャットの内容を取得
            db.collection("textbooks")
            .doc(this.itemID)
            .collection("chat")
            .orderBy("created", "desc") // 最新のものから取得
            .get()
            .then((querySnapshot) => {
                let chats = [];
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    chats.push({
                        userName: data.userName,
                        uid: data.uid,
                        message: data.message,
                        // profilePhoto: data.profilePhoto,
                        date: data.created
                    });
                });
                this.chats = chats;
        })
        .catch((error) => {
            console.log(error);
        });
        },

        //firestoreにメッセージ内容を保存
        addChat() {
            if (this.message === "") {
                alert("メッセージを入力してください。");
                return;
            }
            // Firebaseに保存
            //選択中のitemのしたに、サブコレクションとしてchatコレクションを作成し、
            //そこに(message, uid, userName, profilePhoto, created)を持ったドキュメントを追加する。
            db.collection("textbooks")
            .doc(this.itemID)
            .collection("chat")
            .add({
                message: this.message,
                uid: firebase.auth().currentUser.uid, // ユーザーID
                userName: this.user.displayName, //メッセージを入力したユーザ名
                // profilePhoto: this.user.photoURL,
                created: firebase.firestore.FieldValue.serverTimestamp(),
            })
            .then(function (docRef) {
                console.log("Document written with ID: ", docRef.id);
            })
            .catch((error) => {
                console.error("Error adding document: ", error);
            });

            //出品者以外がコメントしたら、出品者におしらせされる。
            if(firebase.auth().currentUser.uid != this.userID){
                db.collection("users").doc(this.userID).collection("information").doc(this.itemID).set({
                  information: "出品中の商品「"+this.item+"」にコメントがつきました。「"+this.message+"」",
                  isRead: false, //読まれたかどうか
                  timestamp: firebase.firestore.FieldValue.serverTimestamp() //購入された日時
              })
            }

            this.doEmpty()
        },

        //送信ボタンが押されたら、inputのボックスを空にする
        doEmpty(){
            this.message = ''
        }
    
  },
};
</script>

<style scoped>
/* inputタグのスタイル */
.message {
    width: 20%;
    height: 30px;
    margin: 0 auto;
    padding: 0px 10px;
    border-style: solid;
    border-width: 0.5px;
    border-radius: 10px;
}

/* 送信ボタンのスタイル */
.send {
  padding: 8px 24px;
  margin: 15px 0;
  color: white;
  background-color: rgba(255, 0, 0, 0.9);
  display: inline-block;
  opacity: 0.8;
  border-radius: 4px;
  text-align: center;
}
.send:hover {
  background-color: rgba(255, 0, 0, 1);
}


/* .content {
  margin: 0 auto;
  padding: 0 10px;
  max-width: 600px;
} */

section{
  width: 20%;
  margin: 0 auto;
}

.list {
  margin-bottom: 100px;
}
.item {
  position: relative;
  display: flex;
  align-items: flex-end;
  margin-bottom: 0.8em;
}

/* 出品者画像のimgタグのスタイル */
.item-image img {
  
  vertical-align: top;
}
.item-detail {
  margin: 0 0 0 1.4em;
}
.item-name {
  font-size: 75%;
}

.item-message {
  position: relative;
  display: inline-block;
  padding: 0.8em;
  background: #deefe8;
  border-radius: 4px;
  line-height: 1.2em;
}

.item-message::before {
  position: absolute;
  content: " ";
  display: block;
  left: -16px;
  bottom: 12px;
  border: 4px solid transparent;
  border-right: 12px solid #deefe8;
}
/* トランジション用スタイル */
.chat-enter-active {
  transition: all 1s;
}
.chat-enter {
  opacity: 0;
  transform: translateX(-1em);
}

.soldOut {
    background-color: rgb(200, 200, 200);
}

@media all and (max-width:670px){
  .message {
    width: 50%;
  }

  section{
    width: 80%;
  }
}

</style>